import type {
    ClassicalListItem,
    ClassicalListShelf,
    ClassicalShelfItem,
} from '@jet-app/music-classical/api/types';
import type { ObjectGraph } from '@jet/environment/dependencies';
import { uniqueSectionID } from '@jet-app/music-classical/utilities/id-provider';
import { createFlowActionForItem } from '../create-flow-action';
import type { Section } from '@jet-app/music-classical/models/section/Section';
import type {
    TrackListFooter,
    Link,
    TrackListFooterScreenType,
} from '@jet-app/music-classical/models';
import type { ActionModel } from '@jet/environment';

export function transformToTrackListFooter(
    component: ClassicalListShelf,
    objectGraph: ObjectGraph,
    screenType?: TrackListFooterScreenType,
): Section<TrackListFooter> {
    const footerData: Partial<TrackListFooter> = {};

    component.items.forEach((item: ClassicalListItem) => {
        if (item.type === 'text' && item.style === 'trackListFootNote') {
            footerData.description = item.text;
            footerData.hidden = item.hidden;
            footerData.meta = item.meta;
        }

        if (item.type === 'recordLabel') {
            const segueAction = createFlowActionForItem(
                item as unknown as ClassicalShelfItem,
                objectGraph,
            );

            const link: Link = {
                title: item.title,
                segue: segueAction as unknown as ActionModel,
            };

            footerData.linkSection = {
                title: item.subtitle,
                link,
            };
        }
    });

    const hasFooterData = Object.keys(footerData).length > 0;

    const footerItem: TrackListFooter = {
        description: footerData.description || '',
        screenType: (screenType || 'playlist') as TrackListFooterScreenType,
    };

    if (!!footerData.linkSection) {
        footerItem.linkSection = footerData.linkSection;
    }

    if (!!footerData.hidden) {
        footerItem.hidden = footerData.hidden;
    }

    if (!!footerData.meta) {
        footerItem.meta = footerData.meta;
    }

    return {
        id: uniqueSectionID('track-list-footer', objectGraph),
        itemKind: 'trackListFooter',
        presentation: {
            kind: 'single',
        },
        items: hasFooterData ? [footerItem] : [],
    };
}
